import React from 'react';

type CheckedProps = {}

export const Checked: React.FC<CheckedProps> = () => {
  return (
    <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.23472 7.31438L0.912862 3.9724C0.792067 3.8516 0.792067 3.65028 0.912862 3.52948L1.35578 3.08657C1.47657 2.96577 1.67789 2.96577 1.79869 3.08657L4.29511 5.60313C4.37564 5.68365 4.51657 5.68365 4.5971 5.60313L9.48928 0.670674C9.61008 0.549879 9.8114 0.549879 9.9322 0.670674L10.3751 1.11359C10.4959 1.23438 10.4959 1.43571 10.3751 1.5565L4.67763 7.31438C4.55683 7.45531 4.35551 7.45531 4.23472 7.31438Z" fill="#3A4B68"/>
    </svg>
  )
}
